export const removeDuplicates = (products: Listing.IProduct[]) => {
  return products.filter((item, i, productsList) => {
    return productsList.findIndex((product) => product.productId === item.productId) === i;
  });
};

interface GetPromotionTextConfigProps {
  showPriceReveal: boolean;
  salePromotionConfig: {
    mobile: boolean;
    desktop: boolean;
    pdp: {
      pipeColor: string;
      textColor: string;
      text: string;
    };
    plp: {
      pipeColor: string;
      textColor: string;
      text: string;
    };
  };
  isMobile: boolean;
  isOutOfStock: boolean;
  isPriceRevealEnabled: boolean;
}

export const getPromotionTextConfig = ({
  showPriceReveal,
  salePromotionConfig,
  isMobile,
  isOutOfStock,
  isPriceRevealEnabled,
}: GetPromotionTextConfigProps) => {
  const {
    desktop: showPromotionTextDweb,
    mobile: showPromotionTextMweb,
    plp: promotionTextConfig,
  } = salePromotionConfig;

  const promotionTextEligiblity = isMobile ? showPromotionTextMweb : showPromotionTextDweb;

  const showPromotion =
    isPriceRevealEnabled && !showPriceReveal && !isOutOfStock && promotionTextEligiblity;

  return { showPromotion, promotionTextConfig };
};
